// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.home-decor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}
.home-decor__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: 900px;
  max-width: 95%;
  height: 82vh;
  max-height: 780px;
  display: flex;
  flex-direction: column;
  padding: 20px 22px 14px;
  background: radial-gradient(120% 70% at 0% 0%, rgba(255, 255, 255, 0.05), transparent 55%), rgba(11, 15, 19, 0.96);
}
.home-decor__window * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .home-decor__window {
    animation: none;
  }
}
.home-decor__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
}
.home-decor__title {
  margin: 0;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.home-decor__sub {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.home-decor__stats {
  display: flex;
  gap: 8px;
  flex: none;
}
.home-decor__stat {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
}
.home-decor__stat-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  color: var(--gold-light);
}
.home-decor__stat-icon svg {
  width: 100%;
  height: 100%;
}
.home-decor__stat--cap {
  padding-bottom: 10px;
}
.home-decor__meter {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.08);
}
.home-decor__meter span {
  display: block;
  height: 100%;
  background: var(--gold-main);
  transition: width 0.3s ease;
}
.home-decor__tabs {
  display: flex;
  gap: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  margin-bottom: 14px;
}
.home-decor__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.home-decor__tab:hover {
  color: #ebe8e1;
}
.home-decor__tab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.home-decor__tab.is-active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.home-decor__tab-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
}
.home-decor__tab-icon svg {
  width: 100%;
  height: 100%;
}
.home-decor__count {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
}
.home-decor__body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 4px;
  animation: decor-fade 0.2s ease-out;
}
.home-decor__body::-webkit-scrollbar {
  width: 6px;
}
.home-decor__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.home-decor__shop {
  display: grid;
  grid-template-columns: 188px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}
.home-decor__cats {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.home-decor__cat {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.home-decor__cat:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.06);
}
.home-decor__cat:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.home-decor__cat.is-active {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.home-decor__cat-icon {
  display: inline-flex;
  flex: none;
  width: 20px;
  height: 20px;
}
.home-decor__cat-icon svg {
  width: 100%;
  height: 100%;
}
.home-decor__cat-label {
  flex: 1 1 auto;
  min-width: 0;
}
.home-decor__cat-count {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
}
.home-decor__toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.home-decor__search {
  position: relative;
  flex: 1 1 auto;
}
.home-decor__search input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding-left: 36px;
}
.home-decor__search input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.home-decor__search input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.home-decor__search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  width: 17px;
  height: 17px;
  transform: translateY(-50%);
  color: #8d8a82;
  pointer-events: none;
}
.home-decor__search-icon svg {
  width: 100%;
  height: 100%;
}
.home-decor__select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  min-width: 170px;
}
.home-decor__select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.home-decor__select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.home-decor__select option {
  background: #171b24;
  color: #ebe8e1;
}
.home-decor__note {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.home-decor__grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 10px;
}
.home-decor__card {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
  animation: decor-rise 0.34s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: calc(var(--i) * 18ms);
  transition: transform 0.16s ease, border-color 0.16s ease, background-color 0.16s ease;
}
.home-decor__card:hover {
  transform: translateY(-2px);
  border-color: var(--gold-dark);
  background: rgba(255, 255, 255, 0.07);
}
.home-decor__card.is-poor .home-decor__tile-glyph {
  opacity: 0.45;
}
.home-decor__tile {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 92px;
  background: radial-gradient(70% 90% at 50% 100%, rgba(255, 255, 255, 0.08), transparent 70%), rgba(0, 0, 0, 0.28);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  transition: background-color 0.16s ease;
}
.home-decor__card:hover .home-decor__tile-glyph {
  transform: scale(1.08);
  color: var(--gold-light);
}
.home-decor__tile-glyph {
  display: inline-flex;
  width: 52px;
  height: 52px;
  color: var(--gold-main);
  transition: transform 0.2s ease, color 0.2s ease, opacity 0.2s ease;
}
.home-decor__tile-glyph svg {
  width: 100%;
  height: 100%;
  stroke-width: 1.25;
}
.home-decor__card-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px 4px;
}
.home-decor__card-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  color: #ebe8e1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5em;
}
.home-decor__card-meta {
  font-size: 12px;
  color: #8d8a82;
}
.home-decor__card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px 12px;
}
.home-decor__price {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 15px;
  font-weight: 700;
  color: var(--gold-light);
}
.home-decor__price-icon {
  display: inline-flex;
  width: 16px;
  height: 16px;
}
.home-decor__price-icon svg {
  width: 100%;
  height: 100%;
}
.home-decor__card.is-poor .home-decor__price {
  color: #8d8a82;
}
.home-decor__panel {
  padding-bottom: 4px;
}
.home-decor__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 6px;
}
.home-decor__section {
  margin: 16px 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.home-decor__hint {
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.home-decor__rows {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.home-decor__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  animation: decor-rise 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: calc(var(--i, 0) * 16ms);
  transition: border-color 0.14s ease, background-color 0.14s ease;
}
.home-decor__row:hover {
  border-color: var(--gold-dark);
  background: rgba(255, 255, 255, 0.06);
}
.home-decor__row.is-off {
  opacity: 0.6;
}
.home-decor__mini {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 42px;
  height: 42px;
  color: var(--gold-main);
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.home-decor__mini svg {
  width: 26px;
  height: 26px;
}
.home-decor__row-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.home-decor__row-name {
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-decor__row-meta {
  font-size: 12px;
  color: #8d8a82;
}
.home-decor__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 36px 12px;
  text-align: center;
  color: #aeaba2;
}
.home-decor__empty p {
  margin: 0;
  font-size: 14px;
}
.home-decor__empty-icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  color: #8d8a82;
}
.home-decor__empty-icon svg {
  width: 100%;
  height: 100%;
  stroke-width: 1.25;
}
.home-decor__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.home-decor__keyhint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-size: 12px;
}
.home-decor__keyhint kbd {
  padding: 1px 6px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  color: #aeaba2;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}
.home-decor__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
}
.home-decor__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.home-decor__button:active:not(:disabled) {
  transform: translateY(1px);
}
.home-decor__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.home-decor__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.home-decor__button--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.home-decor__button--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.home-decor__button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.home-decor__button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.home-decor__button--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.home-decor__button--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
@media (max-width: 760px) {
  .home-decor__shop {
    grid-template-columns: minmax(0, 1fr);
  }
  .home-decor__cats {
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .home-decor__cat {
    width: auto;
  }
  .home-decor__stats {
    flex-direction: column;
  }
}
@media (prefers-reduced-motion: reduce) {
  .home-decor__body, .home-decor__card, .home-decor__row {
    animation: none;
  }
  .home-decor__card, .home-decor__tile-glyph, .home-decor__meter span {
    transition: none;
  }
  .home-decor__card:hover {
    transform: none;
  }
  .home-decor__card:hover .home-decor__tile-glyph {
    transform: none;
  }
}

@keyframes decor-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes decor-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/HomeDecor/HomeDecor.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yDDeU;ECdV,WAAA;AAMF;AAJE;EDeA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECzJE,oBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kHACE;AAWN;ADNE;EAAI,sBAAA;ACSN;ADoIE;EC9JA;ID8J0C,eAAA;EChI1C;AACF;AAdE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAgBJ;AAbE;EACE,SAAA;EDYF,kDA3BW;EA4BX,gBAAA;EACA,eCbqB;EDcrB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC4CP;AAjBE;EACE,eAAA;EDsBF,eAAA;EACA,gBAAA;EACA,cAlDO;ACgDT;AAlBE;EACE,aAAA;EACA,QAAA;EACA,UAAA;AAoBJ;AAjBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EDdF,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECwCL,eAAA;EACA,gBAAA;EACA,cD/CG;ECgDH,gBAAA;AAqBJ;AAnBI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AAqBN;AAnBM;EAAM,WAAA;EAAa,YAAA;AAuBzB;AApBI;EAAS,oBAAA;AAuBb;AApBE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;AAsBJ;AApBI;EACE,cAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;AAsBN;AAjBE;EACE,aAAA;EACA,QAAA;EACA,kDAAA;EACA,mBAAA;AAmBJ;AAhBE;ED+EA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AC5DF;AD8DE;EAAU,cAnLL;ACwHP;AD4DE;EAAkB,oCAAA;EAAsC,oBAAA;ACxD1D;AAnCI;ED+FF,wBAAA;EACA,qCAAA;ACzDF;AArCI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;AAuCN;AArCM;EAAM,WAAA;EAAa,YAAA;AAyCzB;AArCE;EDgCA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;ACQF;AA9CE;ED0CA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC1CE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;AAkDJ;ADTE;EAAuB,UAAA;ACYzB;ADXE;EAA6B,oCAAA;EAAsC,kBAAA;ACerE;AArDE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;AAuDJ;AApDE;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAsDJ;AAnDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yDD3HQ;EC4HR,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDvIK;ECwIL,uBAAA;EACA,6BAAA;EACA,kBDtIK;ECuIL,eAAA;EACA,kFAAA;AAqDJ;AAnDI;EAAU,cD/IP;EC+IyB,qCAAA;AAuDhC;AAtDI;EAAkB,oCAAA;EAAsC,mBAAA;AA0D5D;AAxDI;EACE,wBAAA;EACA,qCAAA;EACA,sCDtJQ;ACgNd;AAvDI;EACE,oBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAyDN;AAvDM;EAAM,WAAA;EAAa,YAAA;AA2DzB;AAxDI;EAAU,cAAA;EAAgB,YAAA;AA4D9B;AA3DI;ED9BF,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;AC4FF;AAnEE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAqEJ;AAlEE;EACE,kBAAA;EACA,cAAA;AAoEJ;AAlEI;ED3DF,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECqDI,kBAAA;AA4EN;AD/HE;EAAU,aAAA;EAAe,8BAAA;ACmI3B;ADlIE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACyI1G;AAnFE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,cD1LK;EC2LL,oBAAA;AAqFJ;AAnFI;EAAM,WAAA;EAAa,YAAA;AAuFvB;AApFE;ED9EA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECwEE,WAAA;EACA,gBAAA;AA8FJ;ADrKE;EAAU,aAAA;EAAe,8BAAA;ACyK3B;ADxKE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC+K1G;AAvGI;EAAS,mBAAA;EAAqB,cDvM3B;ACkTP;AAxGE;EACE,gBAAA;EDzJF,eAAA;EACA,gBAAA;EACA,cAlDO;ACsTT;AAxGE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AA0GJ;AAvGE;EACE,aAAA;EACA,sBAAA;ED9LF,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECwNL,gBAAA;EACA,8DAAA;EACA,sCAAA;EACA,sFAAA;AA2GJ;AAzGI;EACE,2BAAA;EACA,8BAAA;EACA,qCAAA;AA2GN;AAxGI;EAAoC,aAAA;AA2GxC;AAxGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iHACE;EAEF,kDAAA;EACA,uCAAA;AAwGJ;AArGE;EAA8B,sBAAA;EAAwB,wBAAA;AAyGxD;AAvGE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mEAAA;AAyGJ;AAvGI;EAAM,WAAA;EAAa,YAAA;EAAc,kBAAA;AA4GrC;AAzGE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AA2GJ;AAxGE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDhRG;ECiRH,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AA0GJ;AAvGE;EACE,eAAA;EACA,cDxRK;ACiYT;AAtGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,sBAAA;AAwGJ;AArGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAuGJ;AArGI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;AAuGN;AArGM;EAAM,WAAA;EAAa,YAAA;AAyGzB;AArGE;EAA2B,cDpTpB;AC4ZT;AArGE;EAAW,mBAAA;AAwGb;AAtGE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAwGJ;AArGE;EACE,kBAAA;ED3QF,eAAA;EACA,gBAAA;EACA,cAzDO;AC4aT;AAtGE;EACE,aAAA;EDtRF,eAAA;EACA,gBAAA;EACA,cAlDO;ACibT;AAvGE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAyGJ;AAtGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;ED5TF,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECsVL,6DAAA;EACA,yCAAA;EACA,gEAAA;AA0GJ;AAxGI;EAAU,8BAAA;EAAgC,qCAAA;AA4G9C;AA3GI;EAAW,YAAA;AA8Gf;AA3GE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBDxWK;ACqdT;AA3GI;EAAM,WAAA;EAAa,YAAA;AA+GvB;AA5GE;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA8GJ;AA3GE;EACE,eAAA;EACA,gBAAA;EACA,cD7XG;EC8XH,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6GJ;AA1GE;EAAc,eAAA;EAAiB,cDjYxB;AC+eT;AA3GE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,cD5YK;ACyfT;AA3GI;EAAI,SAAA;EAAW,eAAA;AA+GnB;AA7GI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cDnZG;ACkgBT;AA7GM;EAAM,WAAA;EAAa,YAAA;EAAc,kBAAA;AAkHvC;AA7GE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AA+GJ;AA5GE;EDpXA,eAAA;EACA,gBAAA;EACA,cAlDO;ECsaL,eAAA;AAgHJ;AA9GI;EACE,gBAAA;EACA,yDDnaM;ECoaN,eAAA;EACA,cD7aG;EC8aH,0CAAA;EACA,kBAAA;AAgHN;AA5GE;EDrXA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ACocF;ADpeE;EAAyB,qCAAA;EAAuC,8BAAA;ACwelE;ADveE;EAA0B,0BAAA;AC0e5B;ADzeE;EAAa,YAAA;EAAc,mBAAA;AC6e7B;AD5eE;EAAkB,oCAAA;EAAsC,mBAAA;ACgf1D;AA3II;EDjWF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC+eF;AD7eE;EAAyB,6BAAA;EAA+B,+BAAA;ACif1D;AAnJI;ED1VF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACgfF;AD9eE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACklBT;AA3JI;EDnVF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACifF;AD/eE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACofhF;AAjKE;EACE;IAAU,qCAAA;EAoKZ;EAnKE;IAAU,gBAAA;IAAkB,mBAAA;IAAqB,eAAA;EAwKnD;EAvKE;IAAS,WAAA;EA0KX;EAzKE;IAAW,sBAAA;EA4Kb;AACF;AA1KE;EACE;IAA2B,eAAA;EA6K7B;EA5KE;IAAwC,gBAAA;EA+K1C;EA9KE;IAAgB,eAAA;EAiLlB;EAhLE;IAA8B,eAAA;EAmLhC;AACF;;AAhLA;EACE;IAAO,UAAA;IAAY,0BAAA;EAqLnB;EApLA;IAAO,UAAA;IAAY,eAAA;EAwLnB;AACF;AAtLA;EACE;IAAO,UAAA;EAyLP;EAxLA;IAAO,UAAA;EA2LP;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Furniture shop and manager of a house (/amenager or the ALT menu).\n// One radius scale (the shared 6px), the accent only through the palette tokens,\n// motion limited to transform and opacity and switched off for reduced motion.\n.home-decor {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n\n  &__window {\n    @include ink.panel;\n    @include ink.enter;\n    pointer-events: auto;\n    width: 900px;\n    max-width: 95%;\n    height: 82vh;\n    max-height: 780px;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 22px 14px;\n    background:\n      radial-gradient(120% 70% at 0% 0%, rgba(255, 255, 255, 0.05), transparent 55%),\n      ink.$ink;\n  }\n\n  // ---- header ----------------------------------------------------------\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 14px;\n  }\n\n  &__title {\n    margin: 0;\n    @include ink.title(24px);\n  }\n\n  &__sub {\n    margin: 4px 0 0;\n    @include ink.hint;\n  }\n\n  &__stats {\n    display: flex;\n    gap: 8px;\n    flex: none;\n  }\n\n  &__stat {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 12px;\n    @include ink.block;\n    font-size: 15px;\n    font-weight: 600;\n    color: ink.$text;\n    overflow: hidden;\n\n    &-icon {\n      display: inline-flex;\n      width: 20px;\n      height: 20px;\n      color: var(--gold-light);\n\n      svg { width: 100%; height: 100%; }\n    }\n\n    &--cap { padding-bottom: 10px; }\n  }\n\n  &__meter {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 3px;\n    background: rgba(255, 255, 255, 0.08);\n\n    span {\n      display: block;\n      height: 100%;\n      background: var(--gold-main);\n      transition: width 0.3s ease;\n    }\n  }\n\n  // ---- tabs --------------------------------------------------------------\n  &__tabs {\n    display: flex;\n    gap: 2px;\n    border-bottom: 1px solid ink.$line;\n    margin-bottom: 14px;\n  }\n\n  &__tab {\n    @include ink.tab;\n\n    &.is-active { @include ink.tab-active; }\n\n    &-icon {\n      display: inline-flex;\n      width: 18px;\n      height: 18px;\n\n      svg { width: 100%; height: 100%; }\n    }\n  }\n\n  &__count { @include ink.badge; }\n\n  &__body {\n    @include ink.scroll;\n    flex: 1 1 auto;\n    min-height: 0;\n    padding-right: 4px;\n    animation: decor-fade 0.2s ease-out;\n  }\n\n  // ---- shop --------------------------------------------------------------\n  &__shop {\n    display: grid;\n    grid-template-columns: 188px minmax(0, 1fr);\n    gap: 18px;\n    align-items: start;\n  }\n\n  &__cats {\n    position: sticky;\n    top: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__cat {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 9px 10px;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: ink.$radius;\n    cursor: pointer;\n    transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n\n    &:hover { color: ink.$text; background: rgba(255, 255, 255, 0.06); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n    &.is-active {\n      color: var(--gold-light);\n      background: rgba(255, 255, 255, 0.07);\n      border-color: ink.$line-strong;\n    }\n\n    &-icon {\n      display: inline-flex;\n      flex: none;\n      width: 20px;\n      height: 20px;\n\n      svg { width: 100%; height: 100%; }\n    }\n\n    &-label { flex: 1 1 auto; min-width: 0; }\n    &-count { @include ink.badge; }\n  }\n\n  &__toolbar {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  &__search {\n    position: relative;\n    flex: 1 1 auto;\n\n    input {\n      @include ink.field;\n      padding-left: 36px;\n    }\n  }\n\n  &__search-icon {\n    position: absolute;\n    left: 11px;\n    top: 50%;\n    width: 17px;\n    height: 17px;\n    transform: translateY(-50%);\n    color: ink.$text-3;\n    pointer-events: none;\n\n    svg { width: 100%; height: 100%; }\n  }\n\n  &__select {\n    @include ink.field;\n    width: auto;\n    min-width: 170px;\n\n    option { background: #171b24; color: ink.$text; }\n  }\n\n  &__note {\n    margin: 0 0 12px;\n    @include ink.hint;\n  }\n\n  // The cards: a big glyph tile as the preview, name, price and the action\n  &__grid {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));\n    gap: 10px;\n  }\n\n  &__card {\n    display: flex;\n    flex-direction: column;\n    @include ink.block;\n    overflow: hidden;\n    animation: decor-rise 0.34s cubic-bezier(0.16, 1, 0.3, 1) both;\n    animation-delay: calc(var(--i) * 18ms);\n    transition: transform 0.16s ease, border-color 0.16s ease, background-color 0.16s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      border-color: var(--gold-dark);\n      background: rgba(255, 255, 255, 0.07);\n    }\n\n    &.is-poor .home-decor__tile-glyph { opacity: 0.45; }\n  }\n\n  &__tile {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 92px;\n    background:\n      radial-gradient(70% 90% at 50% 100%, rgba(255, 255, 255, 0.08), transparent 70%),\n      rgba(0, 0, 0, 0.28);\n    border-bottom: 1px solid ink.$line;\n    transition: background-color 0.16s ease;\n  }\n\n  &__card:hover &__tile-glyph { transform: scale(1.08); color: var(--gold-light); }\n\n  &__tile-glyph {\n    display: inline-flex;\n    width: 52px;\n    height: 52px;\n    color: var(--gold-main);\n    transition: transform 0.2s ease, color 0.2s ease, opacity 0.2s ease;\n\n    svg { width: 100%; height: 100%; stroke-width: 1.25; }\n  }\n\n  &__card-body {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding: 10px 12px 4px;\n  }\n\n  &__card-name {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.25;\n    color: ink.$text;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    min-height: 2.5em;\n  }\n\n  &__card-meta {\n    font-size: 12px;\n    color: ink.$text-3;\n  }\n\n  &__card-foot {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 8px 12px 12px;\n  }\n\n  &__price {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--gold-light);\n\n    &-icon {\n      display: inline-flex;\n      width: 16px;\n      height: 16px;\n\n      svg { width: 100%; height: 100%; }\n    }\n  }\n\n  &__card.is-poor &__price { color: ink.$text-3; }\n\n  // ---- lists (my furniture, originals) -----------------------------------\n  &__panel { padding-bottom: 4px; }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 0 0 6px;\n  }\n\n  &__section {\n    margin: 16px 0 6px;\n    @include ink.label;\n  }\n\n  &__hint {\n    margin: 8px 0;\n    @include ink.hint;\n  }\n\n  &__rows {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 10px;\n    @include ink.block;\n    animation: decor-rise 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;\n    animation-delay: calc(var(--i, 0) * 16ms);\n    transition: border-color 0.14s ease, background-color 0.14s ease;\n\n    &:hover { border-color: var(--gold-dark); background: rgba(255, 255, 255, 0.06); }\n    &.is-off { opacity: 0.6; }\n  }\n\n  &__mini {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    width: 42px;\n    height: 42px;\n    color: var(--gold-main);\n    background: rgba(0, 0, 0, 0.28);\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n\n    svg { width: 26px; height: 26px; }\n  }\n\n  &__row-main {\n    flex: 1 1 auto;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__row-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$text;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__row-meta { font-size: 12px; color: ink.$text-3; }\n\n  // ---- empty states ----------------------------------------------------------\n  &__empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 36px 12px;\n    text-align: center;\n    color: ink.$text-2;\n\n    p { margin: 0; font-size: 14px; }\n\n    &-icon {\n      display: inline-flex;\n      width: 44px;\n      height: 44px;\n      color: ink.$text-3;\n\n      svg { width: 100%; height: 100%; stroke-width: 1.25; }\n    }\n  }\n\n  // ---- footer ----------------------------------------------------------------\n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: 10px;\n    padding-top: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__keyhint {\n    @include ink.hint;\n    font-size: 12px;\n\n    kbd {\n      padding: 1px 6px;\n      font-family: ink.$font-text;\n      font-size: 12px;\n      color: ink.$text-2;\n      border: 1px solid ink.$line-strong;\n      border-radius: 4px;\n    }\n  }\n\n  &__button {\n    @include ink.button;\n    @include ink.button-sm;\n\n    &--primary { @include ink.button-primary; }\n    &--danger { @include ink.button-danger; }\n    &--quiet { @include ink.button-quiet; }\n  }\n\n  // Narrow screens: the categories become a row above the grid\n  @media (max-width: 760px) {\n    &__shop { grid-template-columns: minmax(0, 1fr); }\n    &__cats { position: static; flex-direction: row; flex-wrap: wrap; }\n    &__cat { width: auto; }\n    &__stats { flex-direction: column; }\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    &__body, &__card, &__row { animation: none; }\n    &__card, &__tile-glyph, &__meter span { transition: none; }\n    &__card:hover { transform: none; }\n    &__card:hover &__tile-glyph { transform: none; }\n  }\n}\n\n@keyframes decor-rise {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n@keyframes decor-fade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
